export const CANVASING_ACTION = [
	'You approach strangers on the street for donations.',
	'You beg your sister for a donation.',
	'After a dozen doors slammed in your face, somebody finally throws money at you first.',
	'You find some cash stuffed between your couch cushions.',
	'During a break in canvassing, an old lady mistakes you for a beggar and gives you a little money. Score!'
];
